import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
export const DiscussionsSeparator = (param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("hr", {
        className: tailwindMerge("h-px w-full text-grey-5", className),
        ...restOfProps
    });
};
